/**
 * Probably not the best place as these are really general hooks, with well-defined output, but no other use-case or proper place to move.
 */
import useComplexData from 'FieldServices/hooks/useComplexData';
import { ComplexModelEntity } from '@powerednow/models/modelLookup';
import ProductCategoryEntity from '@powerednow/models/productCategory/entity';

export type ProductCategoryTree = ProductCategoryEntity & {
    children?: ProductCategoryTree[],
}[];

export function useProductCategoryTree<T extends ProductCategoryTree>(companyId: number): { loaded: boolean, categoryTree: T[]} {
    const { optionalResult } = useComplexData('Company', companyId, async (company, resultSetter: (_newResult: {
        loaded: boolean,
        categories: ComplexModelEntity<'ProductCategory'>[],
    }) => void) => {
        const ProductCategories = await company.getAllProductCategory();
        const productCategoryEntities = ProductCategories.map(productCategory => productCategory.getData().getDataValues());
        resultSetter({ categories: productCategoryEntities, loaded: true });
    });
    if (!optionalResult?.loaded) {
        return {
            loaded: false,
            categoryTree: [],
        };
    }

    const categoryMap = optionalResult.categories.reduce((acc, curr) => {

        const itemWithChildren = { ...curr, children: [] };
        acc[itemWithChildren.id] = itemWithChildren;
        return acc;
    }, {} as T);

    const categoryTree: T[] = [];

    Object.values(categoryMap).forEach(item => {
        if (!item.parent_id) {
            categoryTree.push(item);
        }

        const parent = categoryMap[item.parent_id];
        if (parent) {
            parent.children.push(item);
        }
    });

    return {
        loaded: true,
        categoryTree,
    };
}
export function useXeroIntegrationSettings(companyId: number) {
    const { optionalResult } = useComplexData('Company', companyId, async (company, resultSetter: (_newResult: {
        loaded: boolean,
        xeroIntegration: ComplexModelEntity<'CompanyIntegration'>,
    }) => void) => {
        const xeroIntegration = await company.getXeroIntegration();
        resultSetter({ xeroIntegration: xeroIntegration.getData().getDataValues(), loaded: true });
    });
    if (!optionalResult?.loaded) {
        return {
            loaded: false,
            xeroIntegration: null,
        };
    }

    return {
        loaded: true,
        xeroIntegration: optionalResult.xeroIntegration,
    };
}
